// extracted by mini-css-extract-plugin
module.exports = {"morePosts":"MorePosts-module--morePosts--2TNxY","morePostItem":"MorePosts-module--morePostItem--jjPNP"};